import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

//COMPONETS
import MainMenu from "./files//mainMenu";
import Categories from "./files/categories";
import Colours from "./files/colours";
import Products from "./files/products";
import Settings from "./files/settings";
import NewProduct from "./files/products/newProduct";
import PostageShipping from "./files/postageShipping";
import Orders from "./files/orders";
import Sales from "./files/sales/sales";
import NewSale from "./files/sales/newSale";
import Policies from "./files/policies";
import OrderDetails from "./files/order/orderDetails";
import PrintingProgress from "./files/order/printingProgress";
import Links from "./files/links";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path={"/"} element={<MainMenu />} />
                        <Route path={"/categories"} element={<Categories />} />
                        <Route path={"/colours"} element={<Colours />} />
                        <Route path={"/post_ship"} element={<PostageShipping />} />
                        <Route path={"/products"} element={<Products />} />
                        <Route path={"/products/newProduct"} element={<NewProduct edit={false} />} />
                        <Route path={"/products/editProduct/:id"} element={<NewProduct edit={true} />} />
                        <Route path={"/orders"} element={<Orders />} />
                        <Route path={"/sales"} element={<Sales />} />
                        <Route path={"/settings"} element={<Settings />} />
                        <Route path={"/sales/new"} element={<NewSale modify={false} />} />
                        <Route path={"/sales/modify/:id"} element={<NewSale modify={true} />} />
                        <Route path={"/policies"} element={<Policies />} />
                        <Route path={"/links"} element={<Links />} />
                        <Route path={"/orderDetails/:id"} element={<OrderDetails />} />
                        <Route path={"/orderDetails/:id/printingProgress"} element={<PrintingProgress />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
